import useInputPreset, { TInputPresets } from './useInputPreset'

export type { TInputPresets }
export { useInputPreset }
